import { Input } from '@fluentui/react-components';
import { Flex } from '../../../../Flex';
import { Text } from '../../../../Text';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface TimeRangeEditorProps {
  from: string;
  to: string;
  errorMessages?: string[];
  fromChanged?: (from: string) => void;
  toChanged?: (to: string) => void;
}

export const TimeRangeEditor: FC<TimeRangeEditorProps> = props => {
  const { from, to, fromChanged, toChanged, errorMessages } = props;
  const { t } = useTranslation();
  return (
    <Flex direction="column" gap="0.5rem">
      <Flex gap="0.5rem" align="center">
        <Input
          appearance="filled-darker"
          type="time"
          value={from}
          onChange={(_, data) => fromChanged?.(data?.value ?? '')}
          data-testid="timeRangeFromInput"
          className="timeRangeFromInput"
          aria-label={t('settings:classbook:timerange:from_a11y', { defaultValue: 'Startzeit' })}
        />
        <Text
          weight="bold"
          size="lg"
          style={{ padding: '0 5px' }}
        >
          -
        </Text>
        <Input
          appearance="filled-darker"
          type="time"
          value={to}
          onChange={(_, data) => toChanged?.(data?.value ?? '')}
          data-testid="timeRangeToInput"
          className="timeRangeFromInput"
          aria-label={t('settings:classbook:timerange:to_a11y', { defaultValue: 'Endzeit' })}
        />
      </Flex>
      {errorMessages?.map((error, index) => (
        <Text color="danger" key={index}>{error}</Text>
      ))}
    </Flex>
  );
};
